import { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';

import { Modal, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const AddToBagUnavailableIngredientsList = (props: PropsWithChildren) => {
  const { children } = props;

  return <Modal.Row style={styles.list}>{children}</Modal.Row>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  list: {
    gap: theme.spacing['2'],
  },
});
